<app-common-list-table
	[request]="getRequest"
	[cols]="cols"
	[filtering]="filter"
	[actionButtonText]="env.canAddFincas ? 'Añadir ' + env.fincaName : ''"
	(actionButtonClick)="add()"
	[globalConditionalStyle]="globalConditionalStyle"
	[globalVisualTransform]="globalVisualTransform"
	[customExportCsv]="env.showFincasCsv"
	(visualize)="show('info', $event)"
	(edit)="edit($event)"
	(remove)="show('delete', $event)"
>
	<ng-template #thEnd>
		@if (env.showCuadernoDeCampo) {
			<th class="rt-icon-col">
				<p class="d-flex justify-content-center mb-0">
					{{ env.appName === 'donjardin' ? 'Registro Transacciones' : 'Cuaderno' }}
				</p>
			</th>
		}

		<th class="rt-actions-col">
			<p class="d-flex justify-content-center mb-0">Acciones</p>
		</th>

		@if (env.showCargaPAC) {
			<th class="rt-icon-col"><p class="d-flex justify-content-center mb-0">PAC</p></th>
		}

		@if (env.showFincasGenGml) {
			<th class="rt-icon-col"><p class="d-flex justify-content-center mb-0">GML</p></th>
		}

		@if (env.activateREA) {
			<th class="rt-icon-col"><p class="d-flex justify-content-center mb-0">REA</p></th>
			<th class="rt-icon-col"><p class="d-flex justify-content-center mb-0">CUE</p></th>
		}
	</ng-template>

    <ng-template #tdEnd let-data let-isFirstRow="isFirstRow">
		@if (env.showCuadernoDeCampo) {
			<td class="rt-icon-col">
				<div class="d-flex justify-content-center">
					<button
						[tourAnchor]="isFirstRow ? 'farmerTour.cuadernoButton' : ''"
						class="finca-action-button finca-action-button--book"
						(click)="show('generate', data); filterSectores()"
						type="button"
					>
						<i class="fa fa-book" aria-hidden="true"></i><span>&nbsp;Generar</span>
					</button>
				</div>
			</td>
		}

		<td class="rt-actions-col">
        <app-action-buttons
          [tourAnchorId]="isFirstRow ? 'farmerTour.rowActions' : ''"
				[hideDelete]="!env.canDeleteFincas"
				[showDuplicate]="env.canDuplicateFinca"
				(duplicateRowButtonEvent)="duplicate(data.data)"
				(editRowButtonEvent)="edit(data.data)"
				(deleteRowButtonEvent)="show('delete', data.data)"
				(showRowButtonEvent)="show('info', data.data)"
			></app-action-buttons>
		</td>

		@if (env.showCargaPAC) {
			<td class="rt-icon-col">
				<div class="d-flex justify-content-center">
					<button
						class="finca-action-button finca-action-button--pac"
						(click)="show('importPAC', data.data)"
						type="button"
						aria-label="Importar PAC"
					>
						<i class="fa fa-upload" aria-hidden="true"></i>
					</button>
				</div>
			</td>
		}

		@if (env.showFincasGenGml) {
			<td class="rt-icon-col">
				<div class="d-flex justify-content-center">
					<button
						class="finca-action-button finca-action-button--gml"
						(click)="generaGML(data.data)"
						type="button"
						aria-label="Generar GML"
					>
						<i class="fa fa-download" aria-hidden="true"></i>
					</button>
				</div>
			</td>
		}

		@if (env.activateREA) {
			<td class="rt-icon-col">
				<div class="d-flex justify-content-center">
					<button
						[tourAnchor]="isFirstRow ? 'farmerTour.reaImportButton' : ''"
						class="finca-action-button finca-action-button--rea"
						(click)="show('importREA', data.data)"
						type="button"
						aria-label="Importar REA"
					>
						<i class="fa fa-download" aria-hidden="true"></i>
					</button>
				</div>
			</td>

			<td class="rt-icon-col">
				<div class="d-flex justify-content-center">
					<button
						[tourAnchor]="isFirstRow ? 'farmerTour.cueButton' : ''"
						pTooltip="Enviar CUE"
						class="finca-action-button finca-action-button--cue"
						(click)="show('sendCUE', data.data)"
						type="button"
						aria-label="Enviar CUE"
					>
						<i
							class="fa"
							[ngClass]="{
								'fa-upload': !['en_proceso', 'no_proceso'].includes(data.data?.estado_cue),
								'fa-spinner fa-spin': data.data?.estado_cue === 'en_proceso',
								'fa-times': data.data?.estado_cue === 'no_proceso',
							}"
							aria-hidden="true"
						></i>
					</button>
				</div>
			</td>
		}
	</ng-template>
</app-common-list-table>

@if (form; as modalForm) {
	<app-modals
		[view]="this"
		[form]="modalForm.formFields"
		[serverUrl]="env.serverUrl"
		[previousData]="model"
		[recordHasAssociatedData]="true"
		[getRequest]="getRequest"
		[deleteRequest]="deleteRequest"
		[historicoREA]="historicoREA"
		(refreshRequested)="refreshList()"
	></app-modals>
}
